import { z } from 'zod';

export const ApiRequestSchema = z.object({
  type: z.string(),
});


export const UploadMediaMetadataSchema = z.object({
  action: z.union([z.literal('uploadMedia'), z.literal('uploadVideoPoster')]),
  filename: z.string(),
  filetype: z.string(),
  mediaId: z.string().optional(),
})

export type UploadMediaMetadata = z.infer<typeof UploadMediaMetadataSchema>;


export enum ApiFilePath {
  upload = 'v2/uploads/',
  download = 'v2/download',
  private = 'v2/file',
}

export enum Codes {
  OK = 0,
  UNKNOWN = 1,
  WARNING = 2,
  ERROR = 3
}

export const Visual = z.enum([
  'bar',
  'line',
  'simple',
]);
export type Visual = z.infer<typeof Visual>;

export const CheckSchema = z.object({
  name: z.string(),
  description: z.string(),
  group: z.string().optional(),
  parent: z.string().optional(),
  result: z.nativeEnum(Codes),
  value: z.union([z.string(), z.number()]),
  time: z.string().optional(),
  count: z.number().optional(),
  visual: Visual.optional(),
});

export type Check = z.infer<typeof CheckSchema>;

export const NotificationSchema = z.object({
  email: z.array(z.string().email()).optional(),
  slack: z.record(z.string(), z.string()).optional(),
});

export const MetaSchema = z.object({
  host: z.string(),
  website: z.string(),
  ttl: z.number().optional(),
  result: z.nativeEnum(Codes),
  tags: z.array(z.string()).optional(),
  time: z.string().optional(),
  notifications: NotificationSchema.optional()
})

export type Meta = z.infer<typeof MetaSchema>;

export const StatusModelSchema = z.object({
  checks: z.array(CheckSchema),
  meta: MetaSchema,
});

export type StatusModel = z.infer<typeof StatusModelSchema>;

export const S3FileSchema = z.object({
  Key: z.string(),
  LastModified: z.coerce.date(),
  Size: z.number()
});

export type S3File = z.infer<typeof S3FileSchema>;
